import { createGetDataReducer } from "./CommonReducer";
import { REVIEWRATINGLIST , REVIEWRAATINGDELETE } from "../../Constants/ReviewRatingConstants";

export const ReviewGetReducer = createGetDataReducer(REVIEWRATINGLIST)
export const ReviewDeleteReducer = createGetDataReducer(REVIEWRAATINGDELETE)